module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSuccess) ? _c('a', {
    attrs: {
      "href": _vm.photo_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "photo-placeholder",
    attrs: {
      "src": _vm.photo_link,
      "alt": "Photo"
    }
  })]) : _c('img', {
    staticClass: "photo-placeholder",
    attrs: {
      "src": _vm.iconImageNotFound,
      "alt": "Photo"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53fb7083!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAttribute/productPhoto.vue
// module id = 1291
// module chunks = 2